import { createSlice } from "@reduxjs/toolkit";
import { initialAccountingImportBulkPaymentBillState } from "./importBulkPaymentBill.types";
import {
  fetchImportBulkBillPaymentList,
  fetchImportBulkPaymentBill,
} from "./importBulkPaymentBillActions";
import { LoadState } from "../../../constants/enums";
import { APIError } from "../../../constants/types";

export const importBulkPaymentBillSlice = createSlice({
  name: "importBulkPaymentBill",
  initialState: initialAccountingImportBulkPaymentBillState,
  reducers: {
    clearImportBulkPaymentBillState: (state) => {
      state = initialAccountingImportBulkPaymentBillState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchImportBulkPaymentBill.pending, (state) => {
        state.billPayment.listLoading = LoadState.InProgress;
        state.billPayment.list = [];
        state.billPayment.listError = null;
      })
      .addCase(fetchImportBulkPaymentBill.fulfilled, (state, action) => {
        state.billPayment.listLoading = LoadState.Loaded;
        state.billPayment.list = action.payload.data;
      })
      .addCase(fetchImportBulkPaymentBill.rejected, (state, action) => {
        state.billPayment.listLoading = LoadState.Failed;
        state.billPayment.list = [];
        state.billPayment.listError = (action.payload as APIError).message;
      })
      .addCase(fetchImportBulkBillPaymentList.pending, (state) => {
        state.billPayment.billListLoading = LoadState.InProgress;
        state.billPayment.billList = [];
        state.billPayment.billListError = null;
      })
      .addCase(fetchImportBulkBillPaymentList.fulfilled, (state, action) => {
        state.billPayment.billListLoading = LoadState.Loaded;
        state.billPayment.billList = action.payload;
      })
      .addCase(fetchImportBulkBillPaymentList.rejected, (state, action) => {
        state.billPayment.billListLoading = LoadState.Failed;
        state.billPayment.billList = [];
        state.billPayment.billListError = (action.payload as APIError).message;
      });
  },
});

export const { clearImportBulkPaymentBillState } =
  importBulkPaymentBillSlice.actions;
export const importBulkPaymentBillReducer = importBulkPaymentBillSlice.reducer;
